module.exports = __webpack_public_path__ + "img/4.fb1e52b0.png";